// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".bb43aa6551c6c7307fdf05fb557a4604.js";
};